import 'firebase/compat/auth';
import FirebaseManager from './firebaseManager.js';

export default class FirebaseAuthManager {
  constructor() {
    this.firebase = FirebaseManager.getInstance();
  }

  async isLogin() {
    return new Promise((res, rej) => {
      this.firebase.auth().onAuthStateChanged(
        (user) => {
          if (user) {
            // User is signed in.
            res(true);
          } else {
            // No user is signed in.
            res(false);
          }
        },
        // Prevent console error
        (error) => rej(error)
      );
    });
  }

  getCurrentUser() {
    return this.firebase.auth().currentUser;
  }

  async signInWithGoogle() {
    try {
      const provider = new this.firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      provider.addScope('profile email');
      const result = await this.firebase.auth().signInWithPopup(provider);
      const accessToken = result.credential.accessToken;
      const user = result.user;
      return { user };
    } catch (error) {
      console.error(error);
    }
  }

  async signInWithApple() {
    try {
      const provider = new this.firebase.auth.OAuthProvider('apple.com');
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      provider.addScope('email');
      provider.addScope('name');
      const result = await this.firebase.auth().signInWithPopup(provider);
      const accessToken = result.credential.accessToken;
      const user = result.user;
      return { user };
    } catch (error) {
      console.error(error);
    }
  }

  async signInWithEmail ({ email, password }) {
    const result = await this.firebase.auth().signInWithEmailAndPassword(email, password);
    const user = result.user;
    return user;
  }

  async fetchSignInMethodsForEmail(email) {
    return this.firebase.auth().fetchSignInMethodsForEmail(email);
  }

  async signOut() {
    return this.firebase.auth().signOut();
  }
}
